import { useLearnerPath } from '../../data/useLearnerPath';
import { GsaProgramDetail } from '../GsaProgramDetail';
import { DegreeProgram } from './DegreeProgram';

/**
 * Program detail. One url, two views: the degree detail for a degree learner,
 * the GSA freemium detail for everyone else.
 *
 * `'both'` lands on the GSA view, and opening a degree programme from there
 * 404s — `GsaProgramDetail` only matches `!isUniversityProgram`. Reviewed and
 * left as is (PR #1120): nothing in set-edu can produce `'both'`. A degree
 * learner is turned away from GSA programmes, and set-edu never creates a
 * degree enrollment, so the combination only exists if someone makes it in the
 * database — and those learners are dealt with by hand.
 *
 * If it becomes a real state, the fix here is not a third branch: switch on the
 * programme instead of the learner, since the url already identifies which one
 * is being opened. `Programs` and `Learning` need an actual choice, because
 * neither url names a programme.
 */
export const ProgramPage = () => {
  const path = useLearnerPath();

  return path === 'degree' ? <DegreeProgram /> : <GsaProgramDetail />;
};
